/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterDto } from '../../models/center-dto';
import { CreateCenterDto } from '../../models/create-center-dto';

export interface AdminCenterControllerCreateByOwnerId$Params {

/**
 * 센터 소유자 ID
 */
  ownerId: string;
      body: CreateCenterDto
}

export function adminCenterControllerCreateByOwnerId(http: HttpClient, rootUrl: string, params: AdminCenterControllerCreateByOwnerId$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
  const rb = new RequestBuilder(rootUrl, adminCenterControllerCreateByOwnerId.PATH, 'post');
  if (params) {
    rb.path('ownerId', params.ownerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterDto>;
    })
  );
}

adminCenterControllerCreateByOwnerId.PATH = '/api/center/admin/{ownerId}';
